import { FormattedMessage } from 'react-intl';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { NoIndex } from '@sorare/core/src/contexts/seo';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import { SaleType, createCardSorts } from '@sorare/core/src/lib/algolia';
import { metadatas } from '@sorare/core/src/lib/seo/football';

import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { AdvancedCardSearch } from '@sorare/marketplace/src/searchCards';
import { clubPageFilters } from '@sorare/marketplace/src/searchCards/football/cardFilters';

import { useLayoutData } from '#src/pages/clubs/$slug/layout.tsx';

const cardSortsWithBestValue = createCardSorts({
  withBestValue: true,
  withHighestAverageScore: true,
  withPopularPlayer: true,
});

const Cards = () => {
  const club = useLayoutData();
  const filters = useDefaultFilters({
    teamSlug: club.slug,
  });

  useTitleAndDescription(
    metadatas.clubCards.title,
    metadatas.clubCards.description,
    {
      club: club.name,
    }
  );

  return (
    <>
      <NoIndex />
      <h1 className="sr-only">
        <FormattedMessage
          id="Football.Club.Cards"
          defaultMessage="{club} Cards"
          values={{ club: club.name }}
        />
      </h1>
      <FullWidthContainer>
        <AdvancedCardSearch
          sport={Sport.FOOTBALL}
          sorts={cardSortsWithBestValue}
          defaultSort="Newly Listed"
          analyticsTags={['Club', 'Football']}
          defaultFilters={filters}
          cardFilters={clubPageFilters}
          topic={{ type: 'team', label: club.name }}
          stackableTypes={[SaleType.PRIMARY_OFFER]}
        />
      </FullWidthContainer>
    </>
  );
};

export default Cards;
